import type { Crew, CrewMember, SiteTask } from "@/lib/workflow";
import type { Raspored } from "@/lib/gradilista";

export function memberOn(
  member: Pick<CrewMember, "vrijedi_od" | "vrijedi_do">,
  day: string,
) {
  return (
    member.vrijedi_od <= day && (!member.vrijedi_do || day <= member.vrijedi_do)
  );
}
export function unassignedWorkers(
  roster: Raspored[],
  crews: Crew[],
  day: string,
  includePending = false,
) {
  const assigned = new Set(
    crews.flatMap((c) =>
      c.clanovi.filter((m) => memberOn(m, day)).map((m) => m.radnik_id),
    ),
  );
  return [
    ...new Map(
      roster
        .filter(
          (r) =>
            (includePending || !r.ceka_blokada_override) &&
            memberOn(r, day) &&
            !assigned.has(r.radnik_id),
        )
        .map((r) => [r.radnik_id, r]),
    ).values(),
  ];
}
export function taskState(task: SiteTask, today: string) {
  if (task.status === "zavrsen") return "Završeno";
  if (task.status === "otkazan") return "Otkazano";
  if (today > task.planirani_do) return "Kasni";
  if (today < task.planirani_od) return "Planirano";
  return "U tijeku";
}
export function crewWithoutTask(crew: Crew, tasks: SiteTask[], today: string) {
  return !tasks.some(
    (t) =>
      t.brigada_id === crew.id &&
      t.status === "aktivan" &&
      memberOn(
        { vrijedi_od: t.planirani_od, vrijedi_do: t.planirani_do },
        today,
      ),
  );
}
